import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { unsubscribe } from '../api/unsubscribe';
const Unsubscribe = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const token = new URLSearchParams(location.search).get('token');

    const [status, setStatus] = useState(null);

    async function unsub() {
        try {
            const result = await unsubscribe(token);
            console.log('Success:', result);
            setStatus('success');
        } catch (err) {
            console.error('Failed to unsubscribe:', err);
            setStatus('error');
        }
    };

    if (!token) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="bg-white p-8 rounded-2xl shadow-lg text-center max-w-md">
                    <h2 className="text-xl font-bold mb-4">Invalid Link</h2>
                    <p className="text-gray-600">This unsubscribe link is invalid or has expired.</p>
                </div>
            </div>
        );
    }

    if (status === 'success') {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-50">
                <div className="bg-white p-8 rounded-2xl shadow-lg text-center max-w-md">
                    <h2 className="text-xl font-bold mb-4 text-green-600">Unsubscribed</h2>
                    <p className="text-green">You’ve been successfully unsubscribed from email reminders.</p>
                    <button
                        onClick={() => navigate('/')}
                        className="mt-4 px-6 py-2 rounded-xl bg-blue hover:bg-rgb(0, 100, 255) text-white font-bold"
                    >
                        Go Home
                    </button>
                </div>
            </div>
        );
    }

    if (status === 'error') {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="bg-white p-8 rounded-2xl shadow-lg text-center max-w-md">
                    <h2 className="text-xl font-bold mb-4 text-red">Something went wrong</h2>
                    <p className="text-black">We couldn’t process your request. The link may have expired.</p>
                    <button
                        onClick={() => navigate('/')}
                        className="mt-4 px-6 py-2 rounded-xl bg-gray hover:bg-BackgroundColor3 font-bold"
                    >
                        Go Home
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center max-w-md">
                <h2 className="text-xl font-bold mb-4">Unsubscribe from Email Reminders</h2>
                <p className="text-gray-600 mb-6">
                Do you really wish to stop receiving email reminders? You can re-enable them anytime in your profile settings.
                </p>
                <div className="flex gap-4 justify-center">
                    <button
                        onClick={() => navigate('/')}
                        className="px-6 py-2 rounded-xl bg-green hover:bg-hoverButtonBackground font-bold"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => unsub()}
                        className="px-6 py-2 rounded-xl bg-red hover:bg-hoverButtonBackground2 text-white font-bold"
                    >
                        Unsubscribe
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Unsubscribe;
